import _defaults from 'lodash/defaults'

import { mergeResourceStores } from '../_helpers/ResourceStore'

export default {
  getters: {
    FinalDocuments: (state, getters) => {
      return _defaults(
        getters.currentTripDashboardId
          ? getters.Trips[getters.currentTripDashboardId].final_documents
          : {},
        {
          'section-heading': 'Final Documents',
          'section-subheading': '<p>Below are the final documents for your trip.</p>',
          resource_stores: []
        }
      )
    },
    FinalDocumentsMergedResourceStore: (state, getters) => {
      return mergeResourceStores(getters.FinalDocuments.resource_stores, 'Final Documents')
    }
  }
}
